import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Phone, Mail } from 'lucide-react';

interface BookingThankYouProps {
  orderNumber: string;
  customerName: string;
}

export function BookingThankYou({
  orderNumber,
  customerName,
}: BookingThankYouProps) {
  const navigate = useNavigate();
  
  return (
    <div className="max-w-2xl mx-auto text-center">
      <div className="mb-8">
        <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
          <CheckCircle className="w-10 h-10 text-green-600" />
        </div>
      </div>

      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        Thank You for Your Booking, {customerName}!
      </h1>
      
      <p className="text-lg text-gray-600 mb-8">
        Your installation request has been received and confirmed.
      </p>

      <div className="bg-white rounded-lg shadow-md p-6 mb-8">
        <div className="text-left space-y-4">
          <div className="flex items-center justify-between border-b border-gray-200 pb-4">
            <div className="flex items-center">
              <span className="text-lg font-semibold text-gray-900">Confirmation Code:</span>
            </div>
            <span className="text-lg font-mono bg-blue-50 text-blue-700 px-3 py-1 rounded">
              {orderNumber}
            </span>
          </div>

          <div className="bg-blue-50 rounded-lg p-4 text-blue-800">
            <p className="text-center">
              A team member will be contacting you soon to confirm your installation date.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg p-6 mb-8">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Need Assistance?</h2>
        <div className="space-y-3">
          <div className="flex items-center justify-center space-x-2 text-gray-700">
            <Phone className="w-5 h-5" />
            <span>1-800-DRYER</span>
          </div>
          <div className="flex items-center justify-center space-x-2 text-gray-700">
            <Mail className="w-5 h-5" />
            <span>support@dryerexpress.com</span>
          </div>
        </div>
      </div>

      <div className="flex justify-center">
        <button
          onClick={() => navigate('/')}
          className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
        >
          Return to Home
        </button>
      </div>
    </div>
  );
}